import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router, ActivatedRoute } from '@angular/router';

declare var $: any,moment : any
@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss']
})
export class SetNewPasswordComponent implements OnInit {

  constructor(
    private util: UtilService,
    private apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  isExistingUser = false

  token = ""

  submitted = false
  username = ""
  userId=""
  newPass = ""
  confirmPass = ""
  oldPassword = "";
  isResetSuccess = false
  tmpUsername = ""
  tmpNewPass = ""

  ngOnInit() {

    //let cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    //this.username = cookieData["username"]
    //this.userId = cookieData["userId"]

    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['id'];
    });

    if(this.token == null || this.token.toString().trim().length == 0){
      this.util.ErrorDialog("ไม่พบข้อมูลการขอกำหนดรหัสผ่าน กรุณาลองใหม่อีกครั้ง")
    }
    else{
      this.validateToken()
    }

  }

  async validateToken(){
    let req = {
      token_id: this.token
    }
    let res: any = await this.apiService.postCustom("Crm", "GetUsernameFromToken", req)
    if(this.util.isSuccessResponse(res)){
      this.username = res.username
      this.token = res.token_id
      this.isExistingUser = true
    }
    else{
      this.util.ErrorDialog("ไม่พบข้อมูลการขอกำหนดรหัสผ่าน กรุณาลองใหม่อีกครั้ง")
    }
  }

  async changePassword() {
    this.submitted = true
    if (this.newPass.length > 0 && this.newPass == this.confirmPass
      && this.passwordValidation()) {
      this.util.ShowWaiting(true)

      let para = "username=" + this.username
      let user: any = await this.apiService.get("crmservice", "callcenterProfile", para)

      if (user != null && user.length > 0) {
        if (user[0].dpa_customwebuserid != null && user[0].dpa_customwebuserid.toString().trim().length != 0) {
          let guidReq: any = {
            dpa_customwebuserid: user[0].dpa_customwebuserid,
            guid: this.token
          }
          this.oldPassword = user[0].dpa_password;
          
          if (this.oldPassword == this.newPass) {
            this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ password ต้องไม่เท่ากับ password เดิม")
          } else {

            let guidRes: any = await this.apiService.post("crmservice", "updateCallcenterGuid", guidReq);
            if (this.util.isSuccessResponse(guidRes) && guidRes.RESMSG == "SUCCESS") {
              let req: any = {
                //username: this.username,
                newPassword: this.newPass,
                //forcechangepassword: true,
                guid: this.token
              }

              var res: any = await this.apiService.put("crmservice", "callcenterChangepassword/" + this.username, req);
              if (this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS") {
                this.isResetSuccess = true
                this.tmpUsername = this.username
                this.tmpNewPass= this.newPass
                this.clear()
                this.username = ""
                
                this.util.ShowWaiting(false)
                this.util.SuccessDialog("เปลี่ยน Password สำเร็จ")
                let thisTs = this
                $('#btnSuccessOK').on('click', function () {
                  thisTs.router.navigate(['login'], { queryParams: { user: thisTs.tmpUsername, pass: thisTs.tmpNewPass } });
                });

               
                //this.DeleteToken(this.token);
                //this.router.navigate(['login']);
              }
              else {
                this.util.ShowWaiting(false)
                this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
              }
            }
            else {
              this.util.ShowWaiting(false)
              this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
            }
          }
          
        }
      }else{
        
        this.util.ShowWaiting(false)
      }
    }
  }

  clear() {
    this.submitted = false
    this.newPass = ""
    this.confirmPass = ""
  }

  close() {
    window.close()
  }

  passwordValidation() {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass)
  }

  DeleteToken(TokenID: any) {
    let ParamObj: any = {
      token_id: TokenID
    };
    this.apiService.postCustom("user", "deletetoken", ParamObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/set-new-password/set-new-password.component.ts